import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "loading" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "loading",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			strokeLinecap: "round",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12,22.5 C17.7989899,22.5 22.5,17.7989899 22.5,12 C22.5,10.9215183 22.3374032,9.88101316 22.0353861,8.90166109 C20.7134592,4.61504265 16.7205082,1.5 12,1.5 C6.20101013,1.5 1.5,6.20101013 1.5,12 C1.5,15.5662289 3.27789011,18.7172093 5.99568095,20.6149518",
				id: "Oval",
				stroke: "currentColor",
				strokeWidth: 3,
				fillRule: "nonzero",
				transform: "translate(12.000000, 12.000000) scale(-1, -1) translate(-12.000000, -12.000000) "
			})
		})
	]
});
const ForwardRef = forwardRef(SvgLoading);
export default ForwardRef;
